import { render, staticRenderFns } from "./CalendeskInformationMessage.vue?vue&type=template&id=5241ff60&scoped=true"
import script from "./CalendeskInformationMessage.vue?vue&type=script&lang=js"
export * from "./CalendeskInformationMessage.vue?vue&type=script&lang=js"
import style0 from "./CalendeskInformationMessage.vue?vue&type=style&index=0&id=5241ff60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5241ff60",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAlert,VIcon})
